import { Panel } from '../components/Card';

export function CreditsRoute() {
  return (
    <div className="min-h-full w-full max-w-[900px] mx-auto px-5 md:px-10 py-6 pb-12 flex flex-col gap-5">
      <div>
        <h1 className="font-display text-3xl font-bold">Credits</h1>
        <p className="text-sm text-ink-muted">Stand on the shoulders.</p>
      </div>
      <Panel className="p-6 space-y-4 text-sm">
        <Block
          title="Cburnett piece set"
          who="Colin M.L. Burnett"
          link="https://github.com/lichess-org/lila/tree/master/public/piece/cburnett"
          license="CC BY-SA 3.0"
        />
        <Block
          title="Merida piece set"
          who="Armando Hernandez Marroquin"
          link="https://github.com/lichess-org/lila/tree/master/public/piece/merida"
          license="GPL via Lichess"
        />
        <Block
          title="Alpha piece set"
          who="Eric Bentzen"
          link="https://github.com/lichess-org/lila/tree/master/public/piece/alpha"
          license="Free for non-commercial use"
        />
        <Block
          title="Outline / Solid / Carved piece sets"
          who="Original Chess: Challenge Cards artwork"
          link="https://github.com/Fawwaz-M/chess-challenge-cards"
          license="Project asset"
        />
        <Block
          title="Cyber Neon / Gold Ebony / Mythic Fantasy piece sets"
          who="Generated with Google Gemini Nano Banana, cropped and recolored for in-app use"
          link="https://deepmind.google/technologies/gemini/"
          license="Generated asset, project use"
        />
        <Block
          title="Bot logic"
          who="Chess: Challenge Cards rule engine"
          link="https://github.com/Fawwaz-M/chess-challenge-cards"
          license="Private project code"
        />
        <Block
          title="Rating system"
          who="Glicko-2 by Mark E. Glickman"
          link="http://www.glicko.net/glicko/glicko2.pdf"
          license="Public-domain math"
        />
        <Block
          title="Fonts"
          who="Fraunces, Inter Tight, JetBrains Mono"
          link="https://fonts.google.com"
          license="SIL OFL 1.1 / Apache 2.0"
        />
      </Panel>
    </div>
  );
}

function Block({
  title,
  who,
  link,
  license,
}: {
  title: string;
  who: string;
  link: string;
  license: string;
}) {
  return (
    <div>
      <div className="font-semibold">{title}</div>
      <div className="text-ink-muted">{who}</div>
      <div className="flex flex-wrap gap-x-3 text-xs mt-1">
        <a href={link} target="_blank" rel="noreferrer" className="text-accent hover:underline">
          {link}
        </a>
        <span className="text-ink-muted">{license}</span>
      </div>
    </div>
  );
}
